type RenameImageAssetArgs = {
    companyId: string;
    currentFilename: string;
    currentUrl: string;
    nextFilename: string;
};

export async function renameImageAsset({
    companyId,
    currentFilename,
    currentUrl,
    nextFilename,
}: RenameImageAssetArgs) {
    const response = await fetch('/api/image-rename', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            companyId,
            currentFilename,
            currentUrl,
            nextFilename,
        }),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(
            payload?.error || 'Failed to save the updated image filename.'
        );
    }

    return payload;
}
